import Masthead from "@/components/site/Masthead";
import Footer from "@/components/site/Footer";

export default function LegalPage({ title, overline, children }) {
  return (
    <main className="bg-bone text-ink">
      <Masthead />
      <section className="border-b border-rule">
        <div className="max-w-[900px] mx-auto px-5 md:px-12 py-20 md:py-28">
          <div className="overline text-ink/60">{overline}</div>
          <h1 className="font-serif font-light text-4xl md:text-6xl tracking-tight leading-[1.05] mt-4">
            {title}
          </h1>
          <div className="mt-12 space-y-6 text-base md:text-lg text-ink/75 font-light leading-relaxed [&_h2]:font-serif [&_h2]:text-2xl [&_h2]:md:text-3xl [&_h2]:text-ink [&_h2]:mt-12 [&_h2]:mb-2 [&_p]:leading-relaxed [&_a]:underline [&_a]:underline-offset-4">
            {children}
          </div>
          <div className="mt-20 pt-8 border-t border-rule flex items-center justify-between">
            <a href="/" className="overline text-ink/60 editorial-link">Voltar à página inicial</a>
            <span className="overline text-ink/40">Última revisão: Abril 2026</span>
          </div>
        </div>
      </section>
      <Footer />
    </main>
  );
}
